import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Link, { LINK_BEHAVIORS } from 'components/Link';
import * as css from './SocialMediaLinksBlock.scss';

const SocialMediaLinksBlock = ({ title, items }) => {
  return (
    <div className={css.socialMediaLinksBlock}>
      <div className={css.socialMediaLinksWrapper}>
        {title && (
          <h2 className={cn(css.socialMediaListTitle, 'h4')}>{title}</h2>
        )}
        {items && items.length > 0 && (
          <ul className={css.socialMediaList}>
            {items.map((item, index) => (
              <li className={css.socialMediaListItem} key={index}>
                <Link
                  url={item.link}
                  text={item.linkText}
                  openInNewTab
                  behavior={LINK_BEHAVIORS.text}
                />
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

SocialMediaLinksBlock.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      linkText: PropTypes.string,
    })
  ),
};

export default SocialMediaLinksBlock;
